import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import SadHouse from '../atoms/icons/SadHouse';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({

  filterError: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    gap: '8px'
  },
  titleError: {
    color: theme.palette.gray.darkGray
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

export default function FilterNotFound({ clearFilters }) {
  const classes = useStyles();

  return (
    <Box className={classes.filterError}>
      <SadHouse />
      <Typography className={classes.titleError} variant="body1" component="p">
        Nenhum resultado encontrado
      </Typography>
      <Typography>
        Edite ou limpe os filtros para voltar
      </Typography>
      <Typography className={classes.link} variant="body2" onClick={() => clearFilters()}>
        Limpar filtros
      </Typography>
    </Box>
  );
}

FilterNotFound.propTypes = {
  clearFilters: PropTypes.func.isRequired
};
